<template>
    <div class="animated fadeIn" v-if="satisfiedDependencies">
        <b-row class="py-2">
            <b-card header="Editar Rol" class="w-100">
                <role-form
                    :permissions="permissions"
                    :initialPermissions="role.permissions"
                    :initialName="role.name"
                    :initialDescription="role.description"
                    :isSystemRole="role.systemRole"
                    @emit-role-form="updateRole($event)">
                    <div class="w-100 d-flex justify-content-between align-items-center m-0 px-3">
                        <div>
                            &nbsp
                        </div>
                        <div>
                            <button
                                type="submit"
                                class="btn btn-brand btn-primary btn-lg"
                                v-if="mixinCheckPermission('ROLE_EDIT')">
                                Guardar
                            </button>
                        </div>
                    </div>
                </role-form>
            </b-card>
        </b-row>
    </div>
</template>

<script>
    import RoleForm from '@/components/roles/RoleForm';
    import {getPermissions} from '@/api/permission-api';
    import {getRole, updateRole} from '@/api/role-api';

    export default {
        name: "edit-role",
        components: {
            RoleForm
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getRole();
            this.getPermissions();
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/admin/roles/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
                permissions: null,
                role: {
                    uuid: null,
                    name: null,
                    description: null,
                    permissions: [],
                    systemRole: null
                }
            };
        },
        computed: {
            satisfiedDependencies() {
                return !!this.permissions && !!this.role.uuid;
            }
        },
        methods: {
            async getPermissions() {
                this.$_loadingMixin_showLoading();
                await getPermissions()
                    .then((permissions) => {
                        this.permissions = permissions;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getRole() {
                this.$_loadingMixin_showLoading();
                await getRole(this.$route.params.uuid)
                    .then((role) => {
                        this.role = role;
                    });
                this.$_loadingMixin_hideLoading();
            },
            updateRole(role) {
                this.$_loadingMixin_showLoading();
                updateRole(this.$route.params.uuid, role)
                    .then(() => {
                        this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                        this.$_loadingMixin_hideLoading();
                        this.$router.push({path: '/admin/roles/list'});
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                        this.$_loadingMixin_hideLoading();
                    });
            }
        }
    }
</script>

<style scoped>

</style>